/**
 * 운동 데이터 표시를 위한 유틸리티 함수
 */

/**
 * 양손 덤벨 운동 여부 확인
 * @param {string} exerciseName - 운동 이름 
 * @returns {boolean} - 양손 덤벨 운동 여부
 */
export const isTwoHandDumbbellExercise = (exerciseName = '') => {
  // 양손 덤벨 운동으로 간주할 운동 목록
  const twoHandExercises = ['덤벨', '해머 컬', '사이드 레터럴 레이즈', '벤트오버 레터럴 레이즈'];
  // 단일 덤벨 운동으로 간주할 운동 목록 (제외할 항목)
  const singleHandExercises = ['원 암', '원암', '싱글'];

  // 양손 덤벨 운동이면서 단일 덤벨 운동이 아닌 경우 true
  return twoHandExercises.some(ex => exerciseName.includes(ex)) && 
         !singleHandExercises.some(ex => exerciseName.includes(ex));
};

/**
 * 무게 표시 포맷팅
 * @param {number|string} weight - 무게 값
 * @param {string} exerciseName - 운동 이름
 * @returns {string} - 포맷팅된 무게 문자열
 */
export const formatWeight = (weight, exerciseName) => {
  if (!weight) return '';
  
  // 양손 덤벨 운동인 경우 kg*2 표시, 아닌 경우 kg만 표시
  return isTwoHandDumbbellExercise(exerciseName) ? 
    `${parseFloat(weight.toString().replace('kg', ''))/2}kg*2` : 
    `${parseFloat(weight.toString().replace('kg', ''))}kg`;
};

/**
 * 횟수 표시 포맷팅
 * @param {number|string} reps - 반복 횟수 
 * @returns {string} - 포맷팅된 횟수 문자열
 */
export const formatReps = (reps) => {
  if (!reps) return '';
  return `${reps.toString().replace('회', '')}회`;
};

/**
 * 시간 표시 포맷팅
 * @param {number|string} duration - 시간(초 단위)
 * @returns {string} - 포맷팅된 시간 문자열 (분:초 형식)
 */
export const formatDuration = (duration) => {
  if (!duration) return '';
  
  // 문자열이 들어온 경우 처리
  if (typeof duration === 'string') {
    // 이미 포맷팅된 문자열인 경우(예: "5분 30초") 그대로 반환
    if (duration.includes('분') || duration.includes('초')) {
      return duration;
    }
    // 숫자 문자열이면 정수로 변환
    duration = parseInt(duration, 10);
  }
  
  // 유효한 숫자가 아니면 빈 문자열 반환
  if (isNaN(duration)) return '';
  
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  
  // 분, 초에 따라 적절한 형식으로 반환
  if (minutes > 0 && seconds > 0) {
    return `${minutes}분 ${seconds}초`;
  } else if (minutes > 0) {
    return `${minutes}분`;
  } else {
    return `${seconds}초`;
  }
}; 